import { render, staticRenderFns } from "./SalesPaymentSuccessful.vue?vue&type=template&id=2526f76b&"
import script from "./SalesPaymentSuccessful.vue?vue&type=script&lang=js&"
export * from "./SalesPaymentSuccessful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports